export default "__VITE_ASSET__C$imVUJL__"